module.exports = __webpack_public_path__ + "static/media/ic_GettingStarted.f90a0937.svg";